module.exports = __webpack_public_path__ + "static/media/AirTicket.34b1032b.png";